import React, { FC, JSX, useEffect } from 'react';
import { useTranslation } from '@/app/i18n/client';
import { useConfig } from '@ibe/components';
import { useGlobalMGLProps } from '@/Util/GlobalMGLPropsContext';
import { enableKlaro } from '@/Tracking/setup';

const Klaro: FC = (): JSX.Element => {
  const { i18n } = useTranslation('klaro');
  const config = useConfig();
  const { magnoliaContext } = useGlobalMGLProps() || {};

  useEffect(() => {
    (async () => {
      if (!magnoliaContext?.isMagnoliaEdit && !magnoliaContext?.isMagnolia) {
        if (config.useConsentManager) {
          await enableKlaro(i18n);
        }
      }
    })();
  }, [magnoliaContext, config]);

  return <></>;
};

export default Klaro;
